(function () {
    function isObject(item) {
        return (item && typeof item === 'object' && !Array.isArray(item));
    }

    function mergeDeep(target, ...sources) {
        if (!sources.length) return target;
        const source = sources.shift();

        if (isObject(target) && isObject(source)) {
            for (const key in source) {
                if (isObject(source[key])) {
                    if (!target[key]) Object.assign(target, { [key]: {} });
                    mergeDeep(target[key], source[key]);
                } else {
                    Object.assign(target, { [key]: source[key] });
                }
            }
        }

        return mergeDeep(target, ...sources);
    }

    const formatErrorObj = (input, val) => {
        let cursor = {};
        const output = {};
        for (let i = 0; i < input.length; i++) {
            const x = input[i];
            if (!i) {
                output[x] = {};
                cursor = output[x];
                continue;
            }

            if (i + 1 === input.length) {
                cursor[x] = val;
                break;
            }
            cursor[x] = {};
            cursor = cursor[x];
        }
        return output;
    };

    clientApp.controller('clientCtrl', function (
        $scope,
        $sce,
        $compile,
        $timeout,
        Client,
        Contact,
        //TODO see task https://restoclub.myjetbrains.com/youtrack/issue/CRM-635
        // ProContact,
        ContactPosition,
        RestaurantGroup,
        MailingType,
        dialogService,
        ngDialog,
        usSpinnerService,
        Task,
        $http,
        toast
    ) {
        $scope.errorObj = {};
        $scope.Math = window.Math;
        $scope.client = [];
        $scope.errors = $sce.trustAsHtml('');
        $scope.contactPositions = [];
        $scope.showProUserConfirmModal = false;
        $scope.mailWarningStatuses = ['red','black'];
        $scope.gender = [
            {'id': 1, name: 'М'},
            {'id': 2, name: 'Ж'}
        ];
        $scope.phoneType = [
            {'id': 1, name: 'Раб'},
            {'id': 2, name: 'Лич'},
            {'id': 3, name: 'Гор'}
        ];

        $scope.userId = $('body').data('user-id');
        $scope.userVisitInfo = {}

        $scope.init = function (clientId) {
            ContactPosition.query({}, function (data) {
                $scope.contactPositions = data;
            });

            MailingType.query({}, function (data) {
                $scope.emailType = data;
            });

            Client.get({'clientId': clientId}, function (data) {
                $scope.client = data;
                usSpinnerService.stop('loading');

                if ($scope.client.actual_comments.length > 0) {
                    var lastCommentDate = moment($scope.client.actual_comments[0].created_at, moment.ISO_8601),
                        currentDate = moment(new Date());

                    if (currentDate.diff(lastCommentDate, 'months') >= 1) {
                        $scope.showConfirmModal = true;
                    }
                }

                if ($scope.client.contacts.length > 0) {
                    $scope.client.contacts.forEach((contact) => {
                        if (undefined !== contact.birth_day) {
                            contact.birth_day = new Date(contact.birth_day);
                            contact.birth_day_formatted = moment(new Date(contact.birth_day)).format('D MMMM YYYY');
                        }

                        if (undefined !== contact.pro_user && contact.pro_user.last_cabinet_visit_at) {
                            let lcv = moment(new Date(contact.pro_user.last_cabinet_visit_at));
                            let now = moment(new Date());

                            $scope.userVisitInfo[`${contact.id}`] = {};
                            $scope.userVisitInfo[`${contact.id}`].lastVisited = moment(lcv).format('D MMMM YYYY - HH:mm');
                            $scope.userVisitInfo[`${contact.id}`].dayAfterVisit = now.diff(lcv, 'days');
                        } else if(undefined !== contact.pro_user && contact.pro_user.last_cabinet_visit_at === null) {
                            $scope.userVisitInfo[`${contact.id}`] = {};
                            $scope.userVisitInfo[`${contact.id}`].lastVisited = null;
                            $scope.userVisitInfo[`${contact.id}`].dayAfterVisit = null;
                        }
                    })
                }

                $scope.updateProUsers();
            });

        };

        var newDialog = function (id, template, model, save, cancel, additionalButton) {
            var buttons = [
                {
                    text: "Сохранить",
                    type: "submit",
                    icons: {
                        primary: "ui-icon-disk"
                    },
                    click: save
                },
                {
                    text: "Закрыть",
                    icons: {
                        primary: "ui-icon-close"
                    },
                    click: cancel
                }
            ];

            if (additionalButton) {
                buttons.push(additionalButton);
            }


            dialogService.open(
                id,
                template,
                model,
                {
                    autoOpen: false,
                    modal: true,
                    width: 500,
                    height: 480,
                    buttons: buttons,
                    create: function (event, ui) {
                        var $dialog = $("#hassle-manager");
                        if ($dialog.dialog("instance")) {
                            $dialog.dialog("close");
                        }
                        var $proUserDialog = $("#pro-user-hassle-manager");
                        if ($proUserDialog.dialog("instance")) {
                            $proUserDialog.dialog("close");
                        }
                    }
                }
            )
        };

        $scope.commentDialog = function (id) {
            if (id) {
                ngDialog.open(
                    {
                        template: 'commentEdit.html',
                        scope: $scope,
                        data: {
                            'save': function () {
                                var $form = $("#form-comment-activity");
                                $.ajax({
                                    url: Routing.generate('app_client_clients_commenteditform', {id: id}),
                                    type: "POST",
                                    data: $form.serialize(),
                                    error: function (XMLHttpRequest) {
                                        $('#commentAddErrors').html(XMLHttpRequest.responseText);
                                    },
                                    success: function (data) {
                                        if (data.success) {
                                            $scope.client.comments = data.comments;
                                            $scope.showConfirmModal = false;
                                            $scope.$apply();
                                            $scope.$$childTail.closeThisDialog();
                                        } else {
                                            $("#comment-edit").html($compile(data)($scope.$$childTail))
                                        }
                                    }
                                });
                            }
                        },
                        closeByDocument: true
                    }
                );
                $scope.$on('ngDialog.opened', function (e, $dialog) {
                    $.post(Routing.generate('app_client_clients_commenteditform', {id: id}), {}, function (data) {
                        $("#comment-edit").html($compile(data)($scope.$$childTail));
                        $scope.$apply();
                    });
                });
            } else {
                var dialog = ngDialog.open(
                    {
                        template: 'comment.html',
                        scope: $scope,
                        data: {
                            'save': function () {
                                var $form = $("#form-comment-activity");
                                $.ajax({
                                    url: $form.attr('action'),
                                    type: "POST",
                                    data: $form.serialize(),
                                    error: function (XMLHttpRequest) {
                                        $('#commentAddErrors').html(XMLHttpRequest.responseText);
                                    },
                                    success: function (data) {
                                        $scope.client.comments.unshift(data);
                                        $scope.client.actual_comments.unshift(data);
                                        $scope.showConfirmModal = false;
                                        $scope.$apply();
                                        dialog.close()
                                    }
                                });
                            }
                        },
                        closeByDocument: true,
                    }
                );
            }
        };

        $scope.editorCommentDialog = function () {
            var dialog = ngDialog.open(
                {
                    template: 'commentEditor.html',
                    scope: $scope,
                    data: {
                        'save': function () {
                            var $form = $("#form-comment-editor");
                            $.ajax({
                                url: $form.attr('action'),
                                type: "POST",
                                data: $form.serialize(),
                                error: function (XMLHttpRequest) {
                                    $('#commentAddErrors').html(XMLHttpRequest.responseText);
                                },
                                success: function (data) {
                                    $scope.client.editor_comments.unshift(data);
                                    $scope.showConfirmModal = false;
                                    $scope.$apply();
                                    dialog.close();
                                }
                            });
                        }
                    },
                    closeByDocument: true
                }
            );
        };

        $scope.taskDialog = function (taskId, editUrl) {
            var dialog = function () {
                $.post(
                    Routing.generate('app_client_clientsimplerest_clientcontacts', {id: $scope.client.id}),
                    {'taskId': taskId},
                    function (contacts) {
                        $('#task_contact')
                            .empty()
                            .append($("<option></option>")
                            .attr("value", '')
                            .text('- выберите клиента -'));
                        $.each(contacts, function(key, contact) {
                            $('#task_contact')
                                .append($("<option></option>")
                                .attr("value", key)
                                .text(contact))
                            ;
                        });
                    }
                );
                var saveTask = function (isCompleted) {
                    return function () {
                        $(".ui-dialog-buttonpane button").button("disable");

                        var $this = $(this);
                        var url = editUrl ? editUrl : $this.attr('action');

                        usSpinnerService.spin('loading');

                        var data = $this.serialize();
                        if (isCompleted) {
                            data += '&completed=1';
                        }
                        $.ajax({
                            url: url,
                            type: "POST",
                            data: data,
                            error: function (XMLHttpRequest) {
                                $('#taskAddErrors').html(XMLHttpRequest.responseText);
                            },
                            success: function (data) {
                                if (!taskId) {
                                    $scope.client.tasks.unshift(data);
                                    $scope.$apply();
                                }

                                dialogService.close('task');

                                if (isCompleted) {
                                    window.location.reload();
                                } else {
                                    Client.get({'clientId': $scope.client.id}, function (data) {
                                        $scope.client = data;
                                    });
                                }
                            },
                            complete: function () {
                                $(".ui-dialog-buttonpane button").button("enable");
                                usSpinnerService.stop('loading');
                            }
                        });
                    }
                };
                var completedButton = null;
                if (taskId) {
                    completedButton = {
                        text: "Выполнено",
                        icons: {
                            primary: "ui-icon-task-completed"
                        },
                        click: saveTask(true)
                    };
                }
                newDialog(
                    'task',
                    'task.html',
                    {},
                    saveTask(),
                    function () {
                        dialogService.cancel('task');
                    },
                    completedButton
                );
            };

            if (taskId) {
                Task.get({'Id': taskId}, function (data) {
                    dialog(taskId);
                    setTimeout(function () {
                        var date = new Date(data.happen_at);
                        $("#task_content").val(data.content);
                        $('input[name="task[type]"][value="' + data.type + '"]').attr('checked', 'checked');
                        $("#task_contact").val(data.contact_id);
                        $("#task_happenAt_date_day").val(date.getDate());
                        $("#task_happenAt_date_month").val(date.getMonth() + 1);
                        $("#task_happenAt_date_year").val(date.getFullYear());
                        $("#task_happenAt_time_hour").val(date.getHours());
                        $("#task_happenAt_time_minute").val(date.getMinutes());
                    }, 0);

                });
            } else {
                dialog();
            }
        };

        $scope.dialog = function (filter, group) {
            group = group | false;
            dialogService.open(
                "contacts",
                group?"groupContacts.html":"contacts.html",
                {
                    scope: $scope,
                    client: $scope.client,
                    filter: filter,
                    gender: $scope.gender,
                    phoneType: $scope.phoneType,
                    emailType: $scope.emailType,
                    group: group,
                    contactPositions: $scope.contactPositions,
                    showError: $scope.errors.length>0,
                    getError: function () {
                      return $scope.errors;
                    },
                    addPhone: function (contact) {
                        contact.phones.push({
                            'type': 1,
                            'phone': ''
                        })
                    },
                    delPhone: function (contact, phone) {
                        var index = contact.phones.indexOf(phone);
                        contact.phones.splice(index, 1);
                    },
                    addEmail: function (contact) {
                        contact.emails.push({
                            'mailing_type': [],
                            'email': ''
                        })
                    },
                    delEmail: function (contact, email) {
                        var index = contact.emails.indexOf(email);
                        contact.emails.splice(index, 1);
                    },
                    addContact: function () {
                        var emptyContact = {
                            first_name: '',
                            phones: [{
                                'type': 1,
                                'phone': ''
                            }],
                            position: 15,
                            emails: [],
                            actual: true,
                            birth_day: null,
                            birth_day_formatted: null,
                            sex: 1,
                            discr: 1,
                            name_for_mailing: true
                        };

                        if (group) {
                            $scope.client.restaurant_group.contacts.unshift(emptyContact);
                        } else {
                            $scope.client.contacts.unshift(emptyContact);
                        }

                        $scope.errorObj = {};

                    }
                },
                {
                    autoOpen: false,
                    modal: true,
                    width: 980,
                    maxHeight: 550,
                    minWidth: 900,
                    maxWidth: '75%',
                    resizable: false,
                    position: 'top',
                    buttons: [
                        {
                            text: "Сохранить",
                            type: "submit",
                            icons: {
                                primary: "ui-icon-disk"
                            },
                            click: function () {
                                $(".ui-dialog-buttonpane button").button("disable");

                                var promise;

                                $scope.errorObj = {};

                                if (group) {
                                    var savedGroup = {contacts: []};

                                    angular.forEach($scope.client.restaurant_group.contacts, function (value) {
                                        value = $.extend({}, value);
                                        if (undefined !== value.birth_day) {
                                            value.birth_day = moment(value.birth_day).format('YYYY-MM-DD');
                                        }

                                        delete(value.discr);
                                        delete(value.full_name);
                                        delete(value.birth_day_formatted);

                                        angular.forEach(value.emails, function (email, key) {
                                            angular.forEach(email.mailing_type, function (type, typeKey) {
                                                if ((typeof type == 'object') && (typeof type != 'undefined')) {
                                                    value.emails[key].mailing_type[typeKey] = type.id;
                                                }
                                            });

                                            delete(value.emails[key].last_spam_mails_status);
                                            delete(value.emails[key].last_status_text);
                                            delete(value.emails[key].mailjet_contact);
                                        });

                                        angular.forEach(value.phones, function (phone, key) {
                                            delete(value.phones[key].type_name);
                                            delete(value.phones[key].deleted_at);
                                        });

                                        if (typeof(value.position) == 'object') {
                                            value.position = value.position.id;
                                        }

                                        savedGroup.contacts.push(value);
                                    });

                                    promise = RestaurantGroup
                                        .update({'groupId': $scope.client.restaurant_group.id}, savedGroup)
                                        .$promise;
                                } else {
                                    var savedClient = {'contacts': [], 'phone': $scope.client.phone};

                                    angular.forEach($scope.client.contacts, function (value) {
                                        if (value.actual === false) {
                                            return;
                                        }

                                        if (undefined !== value.birth_day) {
                                            value.birth_day = moment(value.birth_day).format('YYYY-MM-DD');
                                        }

                                        value = $.extend({}, value);
                                        delete(value.discr);
                                        delete(value.pro_user);
                                        delete(value.birth_day_formatted);
                                        delete(value.full_name);
                                        angular.forEach(value.emails, function (email, key) {
                                            angular.forEach(email.mailing_type, function (type, typeKey) {
                                                if ((typeof type == 'object') && (typeof type != 'undefined')) {
                                                    value.emails[key].mailing_type[typeKey] = type.id;
                                                }
                                            });
                                            delete(value.emails[key].last_spam_mails_status);
                                            delete(value.emails[key].last_status_text);
                                            delete(value.emails[key].mailjet_contact);
                                        });
                                        angular.forEach(value.phones, function (phone, key) {
                                            delete(value.phones[key].type_name);
                                            delete(value.phones[key].deleted_at);
                                        });

                                        if (typeof(value.position) == 'object' && value.position !== null) {
                                            value.position = value.position.id;
                                        } else if (value.position === undefined) {
                                            value.position = 15;
                                        }

                                        savedClient.contacts.push(value);
                                    });


                                    promise = Contact.update({'clientId': $scope.client.id}, savedClient).$promise;
                                }

                                promise.then(
                                    function (resp) {
                                        usSpinnerService.spin('loading');
                                        if(resp.last_error){
                                            toast({
                                                duration  : 50000,
                                                message   : resp.last_error,
                                                position: 'center',
                                                className : "alert-danger"
                                            });
                                            resp.last_error = $sce.trustAsHtml('');
                                        }
                                        Client.get({'clientId': $scope.client.id}, function (data) {
                                            $scope.client = data;
                                            if(!group){$scope.updateProUsers();}
                                            usSpinnerService.stop('loading');
                                            $scope.errors = $sce.trustAsHtml('');
                                            $(".ui-dialog-buttonpane button").button("enable");
                                            if ($scope.client.contacts.length > 0) {
                                                $scope.client.contacts.forEach((contact) => {
                                                    if (undefined !== contact.birth_day) {
                                                        contact.birth_day = new Date(contact.birth_day);
                                                        contact.birth_day_formatted = moment(new Date(contact.birth_day)).format('D MMMM YYYY');
                                                    }
                                                })
                                            }
                                            dialogService.close('contacts');
                                        });
                                    },
                                    function (resp) {
                                        if ($.type(resp.data) === "string"){
                                            $scope.errors = $sce.trustAsHtml(resp.data);
                                            toast({
                                                duration  : 50000,
                                                message   : $scope.errors.toString(),
                                                position: 'center',
                                                className : "alert-danger"
                                            });
                                        }
                                        $(".ui-dialog-buttonpane button").button("enable");
                                    }
                                );

                                promise.catch((response) => {
                                    if (undefined !== response &&
                                        undefined !== response.data &&
                                        undefined !== response.data.violations
                                    ) {
                                        let errorObj = {};
                                        const violations = response.data.violations;
                                        Object.keys(violations).forEach(key => {
                                            const propertyPath = violations[key].propertyPath;
                                            const errorTitle = violations[key].title;

                                            const properties = propertyPath
                                                .split(/\[(.*?)]/)
                                                .filter(el => el.length > 0)
                                            ;

                                            errorObj = mergeDeep(errorObj, formatErrorObj(properties, errorTitle));
                                        });

                                        $scope.errorObj = errorObj;
                                        $timeout(function() {
                                            const scroller = document.getElementsByClassName("border-red")[0];
                                            scroller.scrollIntoView();
                                        }, 0, false);

                                    } else if (undefined !== response.data && undefined !== response.data.last_error) {
                                        toast({
                                            duration  : 50000,
                                            message   : response.data.last_error,
                                            position: 'center',
                                            className : "alert-danger"
                                        });
                                        response.data.last_error = $sce.trustAsHtml('');
                                    }
                                });
                            }
                        },
                        {
                            text: "Закрыть",
                            icons: {
                                primary: "ui-icon-close"
                            },
                            click: function () {
                                dialogService.cancel('contacts');
                                $scope.errors = '';
                                if ($scope.client.contacts.length > 0) {
                                    $scope.client.contacts.forEach((contact) => {
                                        if (undefined !== contact.birth_day) {
                                            contact.birth_day = new Date(contact.birth_day);
                                            contact.birth_day_formatted = moment(new Date(contact.birth_day)).format('D MMMM YYYY');
                                        }
                                    })
                                }
                            }
                        }
                    ]
                }

            )
                .then(
                    function () { // ok
                        $scope.errors = '';
                        $scope.errorObj = {};
                        $scope.updateProUsers();
                    },
                    function () { // cancel
                        $scope.errors = '';
                        $scope.errorObj = {};
                        // Загружаем контакты из базы обратно
                        Client.get({'clientId': $scope.client.id}, function (data) {
                            $scope.client.contacts = data.contacts;
                            $scope.updateProUsers();
                        });
                    }
                );
        };

        $scope.updateProUsers = function () {
            if($scope.client.contacts.length > 0) {
                // Проверка email-ов на прошечность
                angular.forEach($scope.client.contacts, function (contact) {
                    if (contact.actual && contact.emails.length > 0) {
                        const emails = contact.emails;
                        /*
                            Менеджеры не могли видеть всех про-юзеров
                            TODO Код скрывал фактических прошек, если в поводах рассылки нет хотя бы одного типа
                            TODO это недопил, или фича о которой никто не знал, вернуть при необходимости
                            const emails = contact.emails.filter(email => {
                                let hasEmailTypeBesidesTypeBill = false;

                                    email.mailing_type.forEach(type => {
                                        if (type.id !== 1 && !hasEmailTypeBesidesTypeBill) {
                                            hasEmailTypeBesidesTypeBill = true;
                                        }
                                    });
                                }

                                return hasEmailTypeBesidesTypeBill;
                            });
                        */

                        /* TODO see task https://restoclub.myjetbrains.com/youtrack/issue/CRM-635
                            angular.forEach(emails, function (contactEmail) {
                                ProContact.get({
                                    email:contactEmail.id,
                                    client:$scope.client.id
                                }, function (data) {
                                    if(data.success && data.proUser) {
                                        contactEmail.pro = true;
                                        contactEmail.owner = data.proUser.owner;
                                        contactEmail.receive_enquiry = data.proUser.receiveEnquiry;
                                        contactEmail.receive_questions = data.proUser.receiveQuestions;
                                        if(!$scope.showProUserConfirmModal
                                            &&
                                            $scope.mailWarningStatuses.indexOf(contactEmail.last_spam_mails_status) !== -1)
                                        {
                                            $scope.showProUserConfirmModal = true;
                                        }
                                    } else if(data.error&&data.errorMessage) {
                                        toast({
                                            duration:  50000,
                                            message:   data.errorMessage,
                                            position:  'center',
                                            className: "alert-danger"
                                        });
                                    }
                                }, function(error) {
                                    toast({
                                        duration  : 50000,
                                        message   : error,
                                        position: 'center',
                                        className : "alert-danger"
                                    });
                                });
                            });
                        */
                    }
                });
            }
        };

        $scope.dateRecently2Week = function (date) {
            var today = moment(),
                lastLogin = moment(date, moment.ISO_8601);

            return (today.diff(lastLogin, 'weeks') < 2);

        };

        //Счета
        $scope.sendDisabled = false;
        $scope.sendBill = bill.sendBill($scope, ngDialog, usSpinnerService, $http);

        $scope.send = bill.send($scope, ngDialog, usSpinnerService, $http);

        $scope.sendExisting = bill.sendExisting($scope, ngDialog, usSpinnerService, $http);


    })
        .directive('multiselectDropdown', [function () {
            return function ($scope, element, attributes) {
                $scope.$watch(attributes.ngModel, function () {
                    var dropDownElement = $(element[0]); // Get the element as a jQuery element
                    dropDownElement.multiselect({
                        texts: {
                            placeholder: 'повод'
                        }
                    });
                });
            }
        }]);
})();